import type { UserValueSet } from '~/common/model/admin';

import type { TransformUsers } from './_user.type';

/**
 * Prepare users.
 *
 * @param {TransformUsers} users Transform Users.
 *
 * @returns {UserValueSet[]} Users.
 */
export function prepareUsers(users: TransformUsers): UserValueSet[] {
  return Object.entries(users).map(([id, user]) => ({
    ...user,
    id,
  }));
}
